export const quotes = [
  {
    text: "No hay camino para la paz, la paz es el camino.",
    author: "Mahatma Gandhi"
  },
  {
    text: "La vida es aquello que te va sucediendo mientras te empeñas en hacer otros planes.",
    author: "John Lennon"
  },
  {
    text: "El futuro pertenece a quienes creen en la belleza de sus sueños.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "No es el más fuerte de las especies el que sobrevive, tampoco es el más inteligente, sino el que responde mejor al cambio.",
    author: "Charles Darwin"
  },
  {
    text: "La única manera de hacer un gran trabajo es amar lo que haces.",
    author: "Steve Jobs"
  },
  {
    text: "Vivir es lo más raro del mundo. La mayoría de la gente simplemente existe.",
    author: "Oscar Wilde"
  },
  {
    text: "En medio de la dificultad reside la oportunidad.",
    author: "Albert Einstein"
  },
  {
    text: "El éxito es ir de fracaso en fracaso sin perder el entusiasmo.",
    author: "Winston Churchill"
  },
  {
    text: "La inspiración existe, pero debe encontrarte trabajando.",
    author: "Pablo Picasso"
  },
  {
    text: "No esperes el momento perfecto, toma el momento y hazlo perfecto.",
    author: "Proverbio"
  },
  {
    text: "La educación es el arma más poderosa que puedes usar para cambiar el mundo.",
    author: "Nelson Mandela"
  },
  {
    text: "Tu tiempo es limitado, no lo desperdicies viviendo la vida de otra persona.",
    author: "Steve Jobs"
  },
  {
    text: "La felicidad no es algo hecho. Viene de tus propias acciones.",
    author: "Dalai Lama"
  },
  {
    text: "Solo aquellos que se arriesgan a ir demasiado lejos pueden descubrir qué tan lejos pueden llegar.",
    author: "T.S. Eliot"
  },
  {
    text: "La vida es 10% lo que te pasa y 90% cómo reaccionas a ello.",
    author: "Charles R. Swindoll"
  },
  {
    text: "El mejor momento para plantar un árbol fue hace 20 años. El segundo mejor momento es ahora.",
    author: "Proverbio chino"
  },
  {
    text: "No puedes usar la creatividad. Cuanto más uses, más tienes.",
    author: "Maya Angelou"
  },
  {
    text: "La diferencia entre lo ordinario y lo extraordinario es ese pequeño extra.",
    author: "Jimmy Johnson"
  },
  {
    text: "El fracaso es simplemente la oportunidad de comenzar de nuevo, esta vez de forma más inteligente.",
    author: "Henry Ford"
  },
  {
    text: "Los límites, como el miedo, a menudo son sólo una ilusión.",
    author: "Michael Jordan"
  }
]